import React from 'react';

interface RentmanLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const RentmanLogo: React.FC<RentmanLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 30"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Orange background */}
        <rect
          x="0"
          y="0"
          width="100"
          height="30"
          fill="#f97316"
        />
        
        {/* Three ascending white bars */}
        <g fill="#ffffff">
          {/* First bar (leftmost) */}
          <rect x="15" y="20" width="8" height="6" />
          
          {/* Second bar (middle) */}
          <rect x="25" y="15" width="8" height="6" />
          
          {/* Third bar (rightmost) */}
          <rect x="35" y="10" width="8" height="6" />
        </g>
        
        {/* Rentman text */}
        <text
          x="50"
          y="20"
          fontSize="12"
          fontWeight="bold"
          fill="#ffffff"
          fontFamily="Arial, sans-serif"
        >
          RENTMAN
        </text>
      </svg>
    </div>
  );
};

export default RentmanLogo;


